import { Component, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MyListingsService } from '../../services/my-listings.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { PropertyDetailsService } from '../../services/property-details.service';
import { environment } from '../../../environments/environment';
import { ListingCheckoutService } from '../../services/listing-checkout.service';
import { LoginService } from '../../services/login.service';
import { HeaderComponent } from '../header/header.component';
import { ToastService, ToastType } from '../../services/toast.service';
import { AppState } from 'src/app/app.state';
import { Subject, takeUntil } from 'rxjs';
import { UserState } from 'src/state/user.state';

@Component({
  selector: 'app-my-listing',
  templateUrl: './my-listing.component.html',
  styleUrls: ['./my-listing.component.css'],
})
export class MyListingComponent {
  @ViewChild(HeaderComponent) header: HeaderComponent;

  listingId: any;
  listingStatus: string;

  usersListing: any;

  inProgressListing: any = [];
  activeListing: any = [];
  pastListing: any = [];

  isLoader = false;
  isButtonLoader = false;
  historyState: any;
  listingDetails: any;
  propertyDetails: any;
  isNoListingsAvailable = false;
  media_base_url = environment.prospektr_sell_media_url;
  showDeleteDialog: boolean = false;
  delElementInx = 0;
  deleteList: any;
  lOrderId = [];
  listingCheckoutEnabled: boolean;
  haveUnpaidListings: boolean = false;
  atLeastPaidOneListing: boolean = false;
  hidePlanSelection: boolean = false;
  onDestroyNotifier$ = new Subject();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public localStorageService: LocalStorageService,
    public propertyDetailsService: PropertyDetailsService,
    public myListingsService: MyListingsService,
    public listingCheckoutService: ListingCheckoutService,
    public loginService: LoginService,
    public toastService: ToastService,
    public appState: AppState,
    private userState: UserState,
  ) { }

  showDialog(list, i) {
    this.showDeleteDialog = !this.showDeleteDialog;
    this.delElementInx = i;
    this.deleteList = list;
  }

  ngOnInit(): void {
    this.isButtonLoader = true;
    this.appState.companyInfo$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res) => {
        if (res) {
          this.hidePlanSelection = res?.sellSideConfig?.hidePlanSelection || false;

          if (
            res?.sellSideConfig &&
            res?.sellSideConfig?.listingServiceProvider == 'ListingCheckout'
          ) {
            this.listingCheckoutEnabled = true;
          } else {
            this.listingCheckoutEnabled = false;
          }
        }
      });

    this.route.queryParams.subscribe((params) => {
      this.listingId = params['listingId'] ? params['listingId'] : null;
      this.listingStatus = params['status'] ? params['status'] : null;
    });

    if (this.listingId) {
      this.myListingsService.GetListingsById(this.listingId).subscribe({
        next: (res) => {

          if (res && this.listingStatus == 'cancel') {
            this.continue(res);
          } else if (res && this.listingStatus == 'success') {
            this.manage(res, true);
            this.loadSavedSearches();
          } else {
            this.loadSavedSearches();
          }
          this.router.navigate([], {
            queryParams: {},
            replaceUrl: true,
            state: { skipUpdate: true },
          });
        },
        error: (err) => {
          this.loadSavedSearches();
          console.log('GetListingsById err : ', err);
        },
      });
    }
    else {
      this.loadSavedSearches();
    }
  }

  loadListings() {
    this.isButtonLoader = true;
    this.loadSavedSearches();
  }

  loadSavedSearches() {
    if (this.userState?.getUserDetails?.id) {
      let input = {
        where: {
          userId: this.userState?.getUserDetails?.id,
        },
        order: 'id DESC',
      };
      this.myListingsService.GetListings(input).subscribe({
        next: (res) => {
          if (res && res.length > 0) {
            this.usersListing = res;
            for (let index = 0; index < this.usersListing.length; index++) {
              const element = this.usersListing[index];
              if (element.stripePaymentStatus == 'paid') {
                this.atLeastPaidOneListing = true;
              }
              if (element.listingCheckoutStatus == 'Listed') {
                this.activeListing.push(element);
              } else {
                if (this.listingCheckoutEnabled) {
                  if (element.listingCheckoutOrderId != null) {
                    this.lOrderId.push(element.listingCheckoutOrderId);
                    this.inProgressListing.push(element);
                  } else {
                    this.inProgressListing.push(element);
                  }
                } else {
                  this.inProgressListing.push(element);
                  if (
                    !element.stripePaymentStatus ||
                    element.stripePaymentStatus != 'paid'
                  ) {
                    this.haveUnpaidListings = true;
                  }
                }
              }
            }
            if (this.lOrderId.length > 0) {
              this.getOrderInfo(this.lOrderId.join(';'));
            }
            this.isButtonLoader = false;
            this.isNoListingsAvailable = false;
          } else {
            this.isButtonLoader = false;
            this.isNoListingsAvailable = true;
            console.log('GetListings Fails!!!!');
          }
        },
        error: (err) => {
          this.isButtonLoader = false;
          this.isNoListingsAvailable = true;
          console.log('GetListings err : ', err);
        },
      });
    }
  }

  getOrderInfo(orderId) {
    this.listingCheckoutService.GetListingCheckoutToken().subscribe({
      next: (res) => {
        if (res && res.access_token) {
          this.localStorageService.set('lcAccessToken', res.access_token);
          let email = this.userState?.getUserDetails?.userName;

          this.listingCheckoutService.GetOrderInfo(email, orderId).subscribe({
            next: (res) => {
              let lOrderIds =
                res && Object.keys(res).length > 0 ? Object.keys(res) : [];
              if (res && lOrderIds.length > 0) {
                for (let index = 0; index < lOrderIds.length; index++) {
                  let ordId = lOrderIds[index];
                  for (
                    let ind = 0;
                    ind < this.inProgressListing.length;
                    ind++
                  ) {
                    let list = this.inProgressListing[ind];
                    if (list.listingCheckoutOrderId == ordId) {
                      list.listingCheckoutStatus = res[ordId].status;
                      this.updateListing(list.id, {
                        updatedDate: new Date(),
                        listingCheckoutStatus: res[ordId].status,
                      });
                      break;
                    }
                  }
                }
              } else {
                console.log('GetOrderInfo Fails 222 !!!!');
              }
            },
            error: (err) => {
              console.log('GetOrderInfo err : ', err);
            },
          });
        } else {
          console.log('GetListingCheckoutToken Fails!!!!');
        }
      },
      error: (err) => {
        console.log('GetListingCheckoutToken err : ', err);
      },
    });
  }

  continue(list) {
    this.isButtonLoader = true;
    this.getPropertyData(list);
  }

  getPropertyData(list) {
    this.propertyDetailsService
      .GetPropertyData(
        list.StreetAddress,
        list.City,
        list.StateOrProvince,
        list.PostalCode,
        list.unitNumber
      )
      .subscribe({
        next: (res) => {
          if (
            res.Status &&
            res.Status.Message == 'Success' &&
            res.Status.Code == 200
          ) {
            if (
              res.data &&
              res.data.listingDetails &&
              res.data.listingDetails.length > 0
            ) {
              this.listingDetails = res.data.listingDetails[0];
            } else {
              this.listingDetails = null;
            }

            if (
              res.data &&
              res.data.propertyDetails &&
              res.data.propertyDetails.Listing
            ) {
              this.propertyDetails = res.data.propertyDetails.Listing;
            } else {
              this.propertyDetails = null;
            }

            this.redirectListing(list);
          } else {
            this.redirectListing(list);
            console.log('GetPropertyData Not Found !!!');
          }
        },
        error: (err) => {
          this.redirectListing(list);
          this.isButtonLoader = false;
          console.log('GetPropertyData err : ', err);
        },
      });
  }

  deleteListing() {
    this.inProgressListing.splice(this.delElementInx, 1);
    this.showDeleteDialog = !this.showDeleteDialog;
    this.myListingsService.DeleteListingsById(this.deleteList.id).subscribe({
      next: (res) => { },
      error: (err) => {
        console.log('DeleteListingsById err : ', err);
      },
    });
  }

  refresh(list, i, flag) {
    list.isCardLoader = true;
    this.myListingsService.GetListingsById(list.id).subscribe({
      next: (res) => {
        if (res.listingCheckoutOrderId != null) {
          let email = this.userState?.getUserDetails?.userName;
          this.listingCheckoutService
            .GetOrderInfo(email, res.listingCheckoutOrderId)
            .subscribe({
              next: (response) => {
                if (response) {
                  let lKeys = Object.keys(response);
                  let ordId = lKeys[0];

                  res.listingCheckoutStatus = response[ordId].status;
                  res.isCardLoader = false;
                  if (flag == 'active') {
                    this.activeListing[i] = res;
                  } else {
                    this.inProgressListing[i] = res;
                  }

                  this.updateListing(list.id, {
                    updatedDate: new Date(),
                    listingCheckoutStatus: response[ordId].status,
                  });
                } else {
                  res.isCardLoader = false;
                  if (flag == 'active') {
                    this.activeListing[i] = res;
                  } else {
                    this.inProgressListing[i] = res;
                  }
                  console.log('GetOrderInfo Fails!!!!');
                }
              },
              error: (err) => {
                res.isCardLoader = false;
                if (flag == 'active') {
                  this.activeListing[i] = res;
                } else {
                  this.inProgressListing[i] = res;
                }
                console.log('GetOrderInfo err : ', err);
              },
            });
        } else {
          this.toastService.toast(
            'Payment completed but listing is inprogress wait for sometime and try again!!!',
            ToastType.Warning
          );
          res.isCardLoader = false;
          if (flag == 'active') {
            this.activeListing[i] = res;
          } else {
            this.inProgressListing[i] = res;
          }
        }
      },
      error: (err) => {
        list.isCardLoader = false;
        console.log('GetListingsById err : ', err);
      },
    });
  }

  setListingDetails(list) {
    this.historyState['basicHomeData'] = list;

    if (list.plansData) {
      this.historyState['plansData'] = list.plansData;
    }

    if (list.ImageIds && list.ImageIds.length > 0) {
      this.historyState['photosData'] = {
        ImageIds: list.ImageIds,
        photographyRelease: list.photographyRelease,
      };
    }
  }

  redirectListing(list) {
    this.localStorageService.set('myListingId', list.id);
    this.historyState = null;
    this.historyState = { ...list };
    this.historyState = {
      ...this.historyState,
      myListingId: list.id,
      address: list.fullAddress,
      matchAddress: list.matchAddress,
      listingDetails: this.listingDetails,
      propertyDetails: this.propertyDetails,
      isPaymentDone: list.stripePaymentStatus === 'paid',
      stageName: list.stageName,
      imgUrl: list?.imgUrl ? list.imgUrl : null,
    };

    this.historyState['completedIndex'] = list.stage;

    this.isButtonLoader = false;

    this.setListingDetails(list);
    if (list.stripePaymentStatus == 'paid' || this.hidePlanSelection) {
      if (!list.ImageIds || list?.ImageIds.length == 0) {
        this.router.navigateByUrl('/photos', {
          state: this.historyState,
        });
      } else {
        this.router.navigateByUrl('/home-details', {
          state: this.historyState,
        });
      }
    } else if (list.stageName.split(',').indexOf('Listing Details') <= -1) {
      this.router.navigateByUrl('/home-details', {
        state: this.historyState,
      });
    } else {
      this.router.navigateByUrl('/plans', {
        state: this.historyState,
      });
    }
  }

  manage(list, flag) {
    if (flag) {
      this.isButtonLoader = true;
    } else {
      list.isCardLoader = true;
    }
    this.listingCheckoutService.GetListingCheckoutToken().subscribe({
      next: (res) => {
        if (res && res.access_token) {
          this.localStorageService.set('lcAccessToken', res.access_token);

          if (list.listingCheckoutOrderId) {
            this.getLCOrderInfo(list, list.listingCheckoutOrderId);
            if (flag) {
              this.isButtonLoader = false;
              this.toastService.toast(
                'Payment completed, will be redirect shortly to listing checkout to complete the remaining form details!!!',
                ToastType.Warning
              );
            } else {
              list.isCardLoader = false;
            }
          } else {
            this.myListingsService.GetListingsById(list.id).subscribe({
              next: (res) => {
                if (res.listingCheckoutOrderId != null) {
                  this.getLCOrderInfo(list, list.listingCheckoutOrderId);
                  if (flag) {
                    this.isButtonLoader = false;
                    this.toastService.toast(
                      'Payment completed, will be redirect shortly to listing checkout to complete the remaining form details!!!',
                      ToastType.Warning
                    );
                  } else {
                    list.isCardLoader = false;
                  }
                } else {
                  if (!flag) {
                    list.isCardLoader = false;
                    this.toastService.toast(
                      'Payment completed but listing is inprogress wait for sometime and try again!!!',
                      ToastType.Warning
                    );
                  }
                }
              },
              error: (err) => {
                list.isCardLoader = false;
                console.log('GetListingsById err : ', err);
              },
            });
          }
        } else {
          list.isCardLoader = false;
          console.log('GetListingCheckoutToken Fails!!!!');
        }
      },
      error: (err) => {
        list.isCardLoader = false;
        console.log('GetListingCheckoutToken err : ', err);
      },
    });
  }

  getLCOrderInfo(list, orderId) {
    let email = this.userState?.getUserDetails?.userName;
    this.listingCheckoutService.GetOrderInfo(email, orderId).subscribe({
      next: (res) => {
        if (res) {
          let lKeys = Object.keys(res);
          let ordId = lKeys[0];

          console.log('ordId : ', ordId);
          console.log('res[ordId].url : ', res[ordId].url);
          list.listingCheckoutStatus = res[ordId].status;
          this.updateListing(list.id, {
            updatedDate: new Date(),
            listingCheckoutStatus: res[ordId].status,
          });

          window.open(res[ordId].url);
        } else {
          console.log('GetOrderInfo Fails!!!!');
        }
      },
      error: (err) => {
        console.log('GetOrderInfo err : ', err);
      },
    });
  }

  updateListing(listId, updateInput) {
    this.myListingsService.UpdateListing(listId, updateInput).subscribe({
      next: (res) => { },
      error: (err) => {
        console.log('UpdateListing err!!!! :', err);
        this.isLoader = false;
      },
    });
  }
}
